// Quick Shop Modal JavaScript - Loaded once globally
// This file contains all the JavaScript functions for the Quick Shop Modal feature

(function() {
  // Prevent multiple initializations
  if (window.QuickShopFunctionsInitialized) {
    return;
  }
  window.QuickShopFunctionsInitialized = true;
  
  window.quickShopBackdropClickHandler = null;
  
  function resolveOpenQuickShopModal(productId, buttonElement) {
    if (buttonElement) {
      const sourceCard = buttonElement.closest('.CollectionSliderCard, .ProductItem');
      if (sourceCard) {
        const cardModal = sourceCard.querySelector('.QuickShopModal[data-product-id="' + productId + '"]');
        if (cardModal) {
          return cardModal;
        }
      }
    }
    return document.getElementById('QuickShopModal-' + productId);
  }

  function ensureSelectedQuickShopColorVisible(modal) {
    if (!modal) return;

    const colorList = modal.querySelector('.QuickShopModal__ColorList');
    const selectedItem = modal.querySelector('.QuickShopModal__ColorItem.is-selected');

    if (!colorList || !selectedItem) return;

    // Scroll ONLY the quick shop color strip; do not use scrollIntoView
    // because it may scroll/move parent containers (e.g. product card slider).
    const targetLeft = selectedItem.offsetLeft - ((colorList.clientWidth - selectedItem.clientWidth) / 2);
    colorList.scrollTo({
      left: Math.max(0, targetLeft),
      behavior: 'smooth'
    });
  }

  window.openQuickShop = function(productId, buttonElement) {
    // Ensure button is clickable
    if(buttonElement) {
      buttonElement.style.pointerEvents = 'auto';
      buttonElement.disabled = false;
    }
    
    const modal = resolveOpenQuickShopModal(productId, buttonElement);
    if(!modal) {
      return;
    }
    
    // Check if modal is already open - if so, don't reopen
    if(modal.classList.contains('is-open')) {
      console.log('[QuickShop] Modal already open, skipping');
      return;
    }
    
    // Function to open the modal (extracted for reuse)
    const openNewModal = function() {
    
    // Try multiple selectors to find the card
    let card = null;
    if(buttonElement) {
      card = buttonElement.closest('.ProductItem.CollectionSliderCard');
      if(!card) card = buttonElement.closest('.CollectionSliderCard');
      if(!card) card = buttonElement.closest('.ProductItem');
      // Also try finding parent containers
      if(!card) {
        let parent = buttonElement.parentElement;
        let depth = 0;
        while(parent && !card && depth < 10) {
          if(parent.classList && (parent.classList.contains('CollectionSliderCard') || parent.classList.contains('ProductItem'))) {
            card = parent;
            break;
          }
          parent = parent.parentElement;
          depth++;
        }
      }
    }
    
    // Check if mobile (767px and below)
    const isMobile = window.innerWidth <= 1024;
    
    if(card) {
      modal._sourceCard = card;
      // Get wrapper to maintain height
      const wrapper = card.querySelector('.ProductItem__Wrapper');
      const originalMinHeight = wrapper ? wrapper.style.minHeight : '';
      
      // Hide card content sections - ONLY on desktop, not mobile
      if(!isMobile) {
        const imageSection = card.querySelector('.CollectionSliderCard__ImageSection');
        const infoSection = card.querySelector('.ProductItem__Info');
        const actionsSection = card.querySelector('.CollectionSliderCard__Actions');
        
        // if(imageSection) imageSection.style.display = 'none';
        // if(infoSection) infoSection.style.display = 'none';
        // if(actionsSection) actionsSection.style.display = 'none';
      }
      
      if(isMobile) { 
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        
        // Mobile: Find and move backdrop to body first
        const backdrop = document.getElementById('QuickShopModal__Backdrop');
        if(backdrop) {
          if(!document.body.contains(backdrop)) {
            document.body.appendChild(backdrop);
          }
          backdrop.style.display = 'block';
          backdrop.classList.add('is-open');
          
          if(window.quickShopBackdropClickHandler) {
            backdrop.removeEventListener('click', window.quickShopBackdropClickHandler);
          }
          
          window.quickShopBackdropClickHandler = function(e) {
            if(e.target === backdrop) {
              closeQuickShop(productId);
            }
          };
          backdrop.addEventListener('click', window.quickShopBackdropClickHandler);
        }
        
        if(modal.parentElement && modal.parentElement !== document.body) {
          modal.parentElement.removeChild(modal);
        }
        
        if(!document.body.contains(modal)) {
          document.body.appendChild(modal);
        }
        
        modal.style.display = 'flex';
        modal.style.position = 'fixed';
        modal.style.bottom = '0';
        modal.style.left = '0';
        modal.style.right = '0';
        modal.style.top = 'auto';
        modal.style.transform = 'translateY(100%)';
        modal.style.opacity = '0';
        modal.style.visibility = 'visible';
        modal.style.zIndex = '9999';
        
        card.classList.add('modal-open');
        
        // Force reflow
        void modal.offsetHeight;
        
        requestAnimationFrame(() => {
          modal.setAttribute('aria-hidden', 'false');
          modal.classList.add('is-open');
          modal.style.transform = 'translateY(0)';
          modal.style.opacity = '1';
        });
      } else {
        // Desktop and Tablet: Keep in card wrapper
        // Check if tablet (768px to 1023px)
        const isTablet = window.innerWidth >= 768 && window.innerWidth <= 1023;
        
        // Ensure modal is inside the card wrapper
        if(wrapper && !wrapper.contains(modal)) {
          wrapper.appendChild(modal);
        }
        
        // Add class to card to disable hover effects
        card.classList.add('modal-open');
        
        // Show and open modal
        modal.setAttribute('aria-hidden', 'false');
        modal.style.display = 'flex';
        modal.style.opacity = '1';
        modal.style.visibility = 'visible';
        void modal.offsetHeight; // Force reflow
        modal.classList.add('is-open');
        
        // Set wrapper height to match modal exactly - prevents white background showing
        setTimeout(() => {
          if(wrapper && modal) {
            const modalContent = modal.querySelector('.QuickShopModal__Content');
            if(modalContent) {
              // Let modal expand naturally first
              modal.style.height = 'auto';
              modalContent.style.height = 'auto';
              
              // Get actual rendered height of modal after it expands
              const modalHeight = modal.offsetHeight || modal.scrollHeight;
              
              // For desktop and tablet, set wrapper height to match modal exactly
              // This prevents white background showing below modal
              // wrapper.style.height = modalHeight + 'px';
              // wrapper.style.minHeight = modalHeight + 'px';
              // wrapper.style.maxHeight = modalHeight + 'px';
              wrapper.style.overflow = 'hidden';
              
              // Now set modal to fill wrapper (but content can scroll if needed on desktop)
              modal.style.height = '100%';
              if(isTablet) {
                modalContent.style.height = 'auto';
                modalContent.style.overflowY = 'visible';
              } else {
                modalContent.style.height = '100%';
                modalContent.style.overflowY = 'auto';
              }
            }
          }
        }, 100);
      }
      
      // Ensure content is visible
      const modalContent = modal.querySelector('.QuickShopModal__Content');
      if(modalContent) {
        modalContent.style.display = 'flex';
        modalContent.style.visibility = 'visible';
        modalContent.style.opacity = '1'; 
        
        // Force all children to be visible
        const allChildren = modalContent.querySelectorAll('*');
        allChildren.forEach(child => {
          if(window.getComputedStyle(child).display === 'none') {
            child.style.display = '';
          }
          if(window.getComputedStyle(child).visibility === 'hidden') {
            child.style.visibility = 'visible';
          }
          if(window.getComputedStyle(child).opacity === '0') {
            child.style.opacity = '1';
          }
        });
      }
      
      // Get selected color from card and sync with quick shop
      const selectedColorRadio = card.querySelector('.ColorSwatch__Radio:checked');
      if (selectedColorRadio) {
        const colorName = selectedColorRadio.getAttribute('data-color-name') || selectedColorRadio.value;

        // Update color name in modal header
        const colorNameEl = modal.querySelector('#QuickShopColorName-' + productId);
        if (colorNameEl && colorName) {
          colorNameEl.innerText = colorName;
        }

        // Make the same color selected inside the Quick Shop color list
        if (colorName) {
          const colorItems = modal.querySelectorAll('.QuickShopModal__ColorItem');
          if (colorItems && colorItems.length) {
            colorItems.forEach(item => {
              const itemValue = item.getAttribute('data-value');
              if (itemValue === colorName) {
                item.classList.add('is-selected');
              } else {
                item.classList.remove('is-selected');
              }
            });

            // Ensure price / availability are updated for this variant
            if (window.updateQuickShopState) {
              window.updateQuickShopState(productId, modal);
            }

            requestAnimationFrame(function() {
              ensureSelectedQuickShopColorVisible(modal);
            });
          }
        }
      }
    } else {
      // Fallback if card not found
      console.log('[QuickShop] Card not found, using fallback');
      const isMobile = window.innerWidth <= 767;
      
      if(isMobile) {
        console.log('[QuickShop] Fallback - Mobile mode');
        // Prevent body scroll
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        
        // Find and show backdrop
        const backdrop = document.getElementById('QuickShopModal__Backdrop');
        if(backdrop) {
          if(!document.body.contains(backdrop)) {
            document.body.appendChild(backdrop);
          }
          backdrop.style.display = 'block';
          backdrop.classList.add('is-open');
          
          // Remove old click handler if exists
          if(window.quickShopBackdropClickHandler) {
            backdrop.removeEventListener('click', window.quickShopBackdropClickHandler);
          }
          
          // Add click handler to backdrop to close modal
          window.quickShopBackdropClickHandler = function(e) {
            // Only close if clicking directly on backdrop, not on modal content
            if(e.target === backdrop) {
              closeQuickShop(productId);
            }
          };
          backdrop.addEventListener('click', window.quickShopBackdropClickHandler);
        }
        
        // CRITICAL: Remove modal from wherever it is first, then append to body
        if(modal.parentElement && modal.parentElement !== document.body) {
          console.log('[QuickShop] Fallback - Removing modal from:', modal.parentElement.className);
          modal.parentElement.removeChild(modal);
        }
        
        // Move modal to body
        if(!document.body.contains(modal)) {
          console.log('[QuickShop] Fallback - Appending modal to body');
          document.body.appendChild(modal);
        }
        
        // Set fixed positioning for mobile
        modal.style.display = 'flex';
        modal.style.position = 'fixed';
        modal.style.bottom = '0';
        modal.style.left = '0';
        modal.style.right = '0';
        modal.style.top = 'auto';
        modal.style.transform = 'translateY(100%)';
        modal.style.opacity = '0';
        modal.style.visibility = 'visible';
        modal.style.zIndex = '9999';
        void modal.offsetHeight;
        
        requestAnimationFrame(() => {
          modal.setAttribute('aria-hidden', 'false');
          modal.classList.add('is-open');
          modal.style.transform = 'translateY(0)';
          modal.style.opacity = '1';
        });
      } else {
        console.log('[QuickShop] Fallback - Desktop mode');
        // Desktop: No body scroll prevention or backdrop
        modal.style.display = 'flex';
        modal.style.opacity = '1';
        void modal.offsetHeight;
        modal.setAttribute('aria-hidden', 'false');
        modal.classList.add('is-open');
      }
    }

    // Ensure variant state (price + availability) matches the currently selected options
    // This fixes the issue where the default selected size could be sold out
    // but the button still shows "ADD TO CART" until the customer changes size.
    if (window.updateQuickShopState) {
      window.updateQuickShopState(productId, modal);
    }
    }; // End of openNewModal function
    
    // On mobile only: Close any other open modal before opening this one (FAQ accordion behavior)
    const isMobileCheck = window.innerWidth <= 767;
    if(isMobileCheck) {
      const allModals = document.querySelectorAll('.QuickShopModal.is-open');
      let hasClosedModal = false;
      
      allModals.forEach(function(openModal) {
        // Don't close the modal we're about to open
        if(openModal !== modal) {
          // Extract productId from modal ID
          const openModalId =
            openModal.getAttribute('data-product-id') ||
            (openModal.id ? openModal.id.replace('QuickShopModal-', '') : '');
          if(openModalId && window.closeQuickShop) {
            // Close the existing modal
            window.closeQuickShop(openModalId);
            hasClosedModal = true;
          }
        }
      });
      
      // If we closed a modal, wait a bit for animation to complete before opening new one
      if(hasClosedModal) {
        setTimeout(function() {
          // Continue with opening the new modal
          openNewModal();
        }, 350); // Wait for close animation (300ms) + small buffer
        return; // Exit early, will continue in setTimeout
      }
    }
    
    // If no modal was closed, open immediately
    openNewModal();
  };

  window.closeQuickShop = function(productId) {
    let modal = productId
      ? document.querySelector('.QuickShopModal.is-open[data-product-id="' + productId + '"]')
      : null;

    if (!modal) {
      modal = document.querySelector('.QuickShopModal.is-open');
    }

    // Fallback to ID lookup when no open modal is found yet
    if (!modal && productId) {
      modal = document.getElementById('QuickShopModal-' + productId);
    }

    if (!modal) {
      return;
    }

    const resolvedProductId =
      modal.getAttribute('data-product-id') ||
      (modal.id && modal.id.indexOf('QuickShopModal-') === 0
        ? modal.id.replace('QuickShopModal-', '')
        : productId);

    const isMobile = window.innerWidth <= 1024;

    // Find the card BEFORE closing - try multiple methods
    let card = modal._sourceCard || modal.closest('.CollectionSliderCard, .ProductItem');

    // If modal was moved to body, search for card by resolved productId
    if (!card && resolvedProductId) {
      // Try to find card by searching for buttons with this productId
      const buttons = document.querySelectorAll(
        `button[onclick*="openQuickShop('${resolvedProductId}'"]`
      );
      if (buttons.length > 0) {
        const button = buttons[0];
        card = button.closest('.ProductItem.CollectionSliderCard');
        if (!card) card = button.closest('.CollectionSliderCard');
        if (!card) card = button.closest('.ProductItem');
        // Also try finding parent containers
        if (!card) {
          let parent = button.parentElement;
          let depth = 0;
          while (parent && !card && depth < 10) {
            if (
              parent.classList &&
              (parent.classList.contains('CollectionSliderCard') ||
                parent.classList.contains('ProductItem'))
            ) {
              card = parent;
              break;
            }
            parent = parent.parentElement;
            depth++;
          }
        }
      }
    }

    // Also try finding by data attribute if available
    if (!card && resolvedProductId) {
      card = document.querySelector(
        `[data-product-id="${resolvedProductId}"].CollectionSliderCard, [data-product-id="${resolvedProductId}"].ProductItem`
      );
    }

    if (isMobile) {
      // Restore body scroll only on mobile
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      // Hide backdrop
      const backdrop = document.getElementById('QuickShopModal__Backdrop');
      if (backdrop) {
        backdrop.classList.remove('is-open');
        // Remove click handler
        if (window.quickShopBackdropClickHandler) {
          backdrop.removeEventListener('click', window.quickShopBackdropClickHandler);
          window.quickShopBackdropClickHandler = null;
        }
        // Hide backdrop after transition
        setTimeout(() => {
          backdrop.style.display = 'none';
        }, 300);
      }

      // Mobile: Slide down animation
      modal.style.transform = 'translateY(100%)';
      modal.style.opacity = '0';
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');

      setTimeout(() => {
        // Reset modal styles completely for next open
        modal.style.display = 'none';
        modal.style.transform = '';
        modal.style.opacity = '';
        modal.style.visibility = '';

        // Keep modal and backdrop in body for mobile (they're fixed positioned anyway)
        // This ensures they're always accessible for next open
        modal._sourceCard = null;
      }, 300);
    } else {
      // Desktop: Fade out
      modal.setAttribute('aria-hidden', 'true');
      modal.style.opacity = '0';
      modal.classList.remove('is-open');

      setTimeout(() => {
        modal.style.display = 'none';
        modal.style.opacity = '';
        modal._sourceCard = null;
      }, 300);
    }

    // Remove modal-open class and restore card content
    if (card) {
      // On mobile, add a small delay before removing modal-open to prevent flickering
      // On desktop, remove immediately
      const restoreCard = () => {
        // Remove modal-open class to re-enable hover effects and pointer events
        card.classList.remove('modal-open');

        // Force pointer-events to be restored
        card.style.pointerEvents = '';

        const wrapper = card.querySelector('.ProductItem__Wrapper');
        const imageSection = card.querySelector('.CollectionSliderCard__ImageSection');
        const infoSection = card.querySelector('.ProductItem__Info');
        const actionsSection = card.querySelector('.CollectionSliderCard__Actions');

        // Restore content
        if (imageSection) imageSection.style.display = '';
        if (infoSection) infoSection.style.display = '';
        if (actionsSection) {
          actionsSection.style.display = '';
          // On mobile, ensure actions are properly visible and positioned
          if (isMobile) {
            actionsSection.style.opacity = '';
            actionsSection.style.visibility = '';
            actionsSection.style.transform = '';
          }
        }

        // Reset wrapper height completely
        if (wrapper) {
          wrapper.style.height = '';
          wrapper.style.minHeight = '';
          wrapper.style.maxHeight = '';
          wrapper.style.overflow = '';
        }

        // Reset modal height
        const cardModal = card.querySelector('.QuickShopModal');
        if (cardModal) {
          cardModal.style.height = '';
          const modalContent = cardModal.querySelector('.QuickShopModal__Content');
          if (modalContent) {
            modalContent.style.height = '';
            modalContent.style.overflowY = '';
          }
        }

        // Ensure buttons are clickable
        const buttons = card.querySelectorAll('button[onclick*="openQuickShop"]');
        buttons.forEach((btn) => {
          btn.style.pointerEvents = '';
          btn.disabled = false;
        });
      };

      // Only add delay on mobile to prevent flickering
      if (isMobile) {
        setTimeout(restoreCard, 50);
      } else {
        restoreCard();
      }
    } else {
      // Fallback: remove modal-open from all cards (in case we couldn't find the specific one)
      const removeModalOpen = () => {
        document
          .querySelectorAll('.CollectionSliderCard.modal-open, .ProductItem.modal-open')
          .forEach((c) => {
            c.classList.remove('modal-open');
            c.style.pointerEvents = '';
          });
      };

      if (isMobile) {
        setTimeout(removeModalOpen, 50);
      } else {
        removeModalOpen();
      }
    }
  };

  window.scrollColors = function(btn, dir) {
    // Find closest color list
    const wrapper = btn.closest('.QuickShopModal__ColorSlider');
    const list = wrapper.querySelector('.QuickShopModal__ColorList');
    if(list) {
      list.scrollBy({ left: dir * 100, behavior: 'smooth' });
    }
  };

  window.selectQuickShopColor = function(el, productId, value) {
    // Highlight logic
    const list = el.parentElement;
    list.querySelectorAll('.QuickShopModal__ColorItem').forEach(item => item.classList.remove('is-selected'));
    el.classList.add('is-selected');

    // Update Color Name in Header
    const modal = el.closest('.QuickShopModal');
    const colorNameEl = modal ? modal.querySelector('#QuickShopColorName-' + productId) : document.getElementById('QuickShopColorName-' + productId);
    if(colorNameEl && value) {
      colorNameEl.innerText = value;
    }

    // Update Variant State
    window.updateQuickShopState(productId, modal);
    ensureSelectedQuickShopColorVisible(modal || document.getElementById('QuickShopModal-' + productId));
  };

  function syncQuickShopSizeSelection(modal, productId, selectedValue) {
    const sizeInputs = modal.querySelectorAll('input[name="size-' + productId + '"]');
    if (!sizeInputs.length) return;

    let hasMatch = false;
    sizeInputs.forEach(input => {
      const isMatch = selectedValue && input.value === selectedValue;
      input.checked = isMatch;
      const label = input.closest('.QuickShopModal__SizeOption');
      if (label) {
        label.classList.toggle('is-selected', isMatch);
      }
      if (isMatch) {
        hasMatch = true;
      }
    });

    if (!hasMatch) {
      const firstInput = sizeInputs[0];
      firstInput.checked = true;
      const firstLabel = firstInput.closest('.QuickShopModal__SizeOption');
      if (firstLabel) {
        firstLabel.classList.add('is-selected');
      }
    }
  }

  function normalizeQuickShopOptionValue(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function resolveQuickShopModal(productId, sourceEl) {
    if (sourceEl) {
      const sourceModal = sourceEl.closest('.QuickShopModal');
      if (sourceModal) return sourceModal;
    }

    const openModal = document.querySelector('.QuickShopModal.is-open[data-product-id="' + productId + '"]');
    if (openModal) return openModal;

    return document.getElementById('QuickShopModal-' + productId);
  }

  function updateQuickShopVariantLinks(modal, variantId) {
    if (!modal || !variantId) return;

    const links = modal.querySelectorAll('.QuickShopModal__LensesLink, .QuickShopModal__Btn');
    links.forEach(link => {
      const rawHref = link.getAttribute('href') || '';
      if (!rawHref) return;

      let baseHref = link.getAttribute('data-base-href');
      if (!baseHref) {
        // Persist a stable base URL so repeated option changes don't accumulate params.
        baseHref = rawHref;
        link.setAttribute('data-base-href', baseHref);
      }

      try {
        const url = new URL(baseHref, window.location.origin);
        url.searchParams.set('variant', String(variantId));
        if (link.classList.contains('QuickShopModal__LensesLink')) {
          url.searchParams.set('open-prescription', 'true');
        } else {
          url.searchParams.delete('open-prescription');
        }
        // Keep variant_id for integrations that read this specific param.
        // url.searchParams.set('variant_id', String(variantId));
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (e) {
        // Fallback for malformed URLs: append query params manually.
        const separator = baseHref.indexOf('?') === -1 ? '?' : '&';
        const prescriptionParam = link.classList.contains('QuickShopModal__LensesLink')
          ? '&open-prescription=true'
          : '';
        link.setAttribute('href', baseHref + separator + 'variant=' + encodeURIComponent(String(variantId)) + prescriptionParam);
      }
    });
  }

  window.selectQuickShopSize = function(labelEl, productId) {
    if (!labelEl) return;
    const modal = resolveQuickShopModal(productId, labelEl);
    if (!modal) return;

    const input = labelEl.querySelector('input[name="size-' + productId + '"]');
    if (!input) return;

    syncQuickShopSizeSelection(modal, productId, input.value);
    window.updateQuickShopState(productId, modal);
  };

  window.updateQuickShopState = function(productId, modalEl) {
    // Gather selected options
    const modal = modalEl || resolveQuickShopModal(productId);
    if(!modal) return;
    
    // Color
    const selectedColorEl = modal.querySelector('.QuickShopModal__ColorItem.is-selected');
    const selectedColor = selectedColorEl ? selectedColorEl.dataset.value : null;

    // Size
    let selectedSizeInput = modal.querySelector('input[name="size-' + productId + '"]:checked');
    // Safeguard: if no size is checked (can happen on initial load in some cases),
    // programmatically check the first available size option so CSS :checked styles apply.
    if (!selectedSizeInput) {
      selectedSizeInput = modal.querySelector('input[name="size-' + productId + '"]');
      if (selectedSizeInput) {
        selectedSizeInput.checked = true;
      }
    }
    const selectedSize = selectedSizeInput ? selectedSizeInput.value : null;
    syncQuickShopSizeSelection(modal, productId, selectedSize);

    // Find Variant
    const select = document.getElementById('QuickShopVariants-' + productId);
    if(!select) return;
    
    const options = select.options;
    let foundVariant = null;
    const normalizedSelectedColor = normalizeQuickShopOptionValue(selectedColor);
    const normalizedSelectedSize = normalizeQuickShopOptionValue(selectedSize);

    for (let i = 0; i < options.length; i++) {
      const opt = options[i];
      const variantOptions = opt.getAttribute('data-options').split(',');
      const normalizedVariantOptions = variantOptions.map(normalizeQuickShopOptionValue);
      // Check matches
      let match = true;
      if (selectedColor && !normalizedVariantOptions.includes(normalizedSelectedColor)) match = false;
      
      if (selectedSize && !normalizedVariantOptions.includes(normalizedSelectedSize)) match = false;

      if (match) {
        foundVariant = opt;
        break;
      }
    }

    // If current UI selections don't map to a real variant (common on first open),
    // fall back to the first variant and sync UI to it so state remains consistent.
    if (!foundVariant && options.length > 0 && modal.getAttribute('data-qs-initialized') !== 'true') {
      const defaultOptionsAttr = modal.getAttribute('data-default-options');
      const defaultOptions = defaultOptionsAttr ? defaultOptionsAttr.split('||') : [];
      if (defaultOptions.length) {
        for (let i = 0; i < options.length; i++) {
          const opt = options[i];
          const variantOptions = opt.getAttribute('data-options').split(',');
          const normalizedVariantOptions = variantOptions.map(normalizeQuickShopOptionValue);
          const hasAllDefault = defaultOptions.every(
            optionValue => normalizedVariantOptions.includes(normalizeQuickShopOptionValue(optionValue))
          );
          if (hasAllDefault) {
            foundVariant = opt;
            break;
          }
        }
      }

      if (!foundVariant) {
        foundVariant = options[0];
      }
      const fallbackVariantOptions = foundVariant.getAttribute('data-options').split(',');

      if (fallbackVariantOptions.length) {
        const colorItems = modal.querySelectorAll('.QuickShopModal__ColorItem');
        if (colorItems.length) {
          colorItems.forEach(item => {
            const itemValue = item.getAttribute('data-value');
            if (fallbackVariantOptions.includes(itemValue)) {
              item.classList.add('is-selected');
            } else {
              item.classList.remove('is-selected');
            }
          });
        }

        const sizeInputs = modal.querySelectorAll('input[name="size-' + productId + '"]');
        if (sizeInputs.length) {
          const fallbackSize = sizeInputs.length
            ? fallbackVariantOptions.find(optionValue => Array.from(sizeInputs).some(input => input.value === optionValue))
            : null;
          syncQuickShopSizeSelection(modal, productId, fallbackSize);
        }
      }
    }

    modal.setAttribute('data-qs-initialized', 'true');

    // Update UI
    if (foundVariant) {
      const selectedVariantId = foundVariant.value;
      const price = foundVariant.getAttribute('data-price');
      const compare = foundVariant.getAttribute('data-compare');
      
      const priceEl = modal.querySelector('.QuickShopModal__Price');
      if(priceEl) priceEl.innerText = price;
      
      const compareEl = modal.querySelector('.QuickShopModal__ComparePrice');
      if (compare && compare !== price) { // simple check logic
        compareEl.innerText = compare;
        compareEl.style.display = 'inline';
      } else {
        if(compareEl) compareEl.style.display = 'none';
      }
      
      // Keep header color label aligned with the active swatch.
      const activeColorEl = modal.querySelector('.QuickShopModal__ColorItem.is-selected');
      const activeColor = activeColorEl ? activeColorEl.dataset.value : selectedColor;
      if (activeColor) {
        const colorNameEl = modal.querySelector('#QuickShopColorName-' + productId);
        if(colorNameEl) {
          colorNameEl.innerText = activeColor;
        }
      }
      
      // Available?
      const addBtn = modal.querySelector('.QuickShopModal__Btn--solid');
      if(addBtn) {
        if(foundVariant.getAttribute('data-available') === 'true') {
          addBtn.innerText = 'ADD TO CART';
          addBtn.disabled = false;
          addBtn.style.cursor = ''; // default (usually pointer via CSS)
        } else {
          addBtn.innerText = 'SOLD OUT';
          addBtn.disabled = true;
          addBtn.style.cursor = 'not-allowed';
        }
      }

      // Keep lenses link in sync with currently selected variant.
      updateQuickShopVariantLinks(modal, selectedVariantId);
    }
  };

  window.addQuickShopToCart = function(productId, triggerEl) {
    
    const modal = resolveQuickShopModal(productId, triggerEl);
    if(!modal) return; // safety
    
    const selectedColorEl = modal.querySelector('.QuickShopModal__ColorItem.is-selected');
    const selectedColor = selectedColorEl ? selectedColorEl.getAttribute('data-value') : null;
    let selectedSizeInput = modal.querySelector('input[name="size-' + productId + '"]:checked');
    if (!selectedSizeInput) {
      selectedSizeInput = modal.querySelector('input[name="size-' + productId + '"]');
      if (selectedSizeInput) {
        selectedSizeInput.checked = true;
      }
    }
    const selectedSize = selectedSizeInput ? selectedSizeInput.value : null;

    const select = document.getElementById('QuickShopVariants-' + productId);
    if(!select) return;
    
    const options = select.options;
    let foundId = null;
    const normalizedSelectedColor = normalizeQuickShopOptionValue(selectedColor);
    const normalizedSelectedSize = normalizeQuickShopOptionValue(selectedSize);

    for (let i = 0; i < options.length; i++) {
      const opt = options[i];
      const variantOptions = opt.getAttribute('data-options').split(',');
      const normalizedVariantOptions = variantOptions.map(normalizeQuickShopOptionValue);
      // Strict-ish match
      if (selectedColor && !normalizedVariantOptions.includes(normalizedSelectedColor)) continue;
      if (selectedSize && !normalizedVariantOptions.includes(normalizedSelectedSize)) continue;
      foundId = opt.value;
      break;
    }

    if (foundId) {
      const formData = {
        'items': [{
          'id': foundId,
          'quantity': 1
        }]
      };
      
      // Visual Loading State
      const addBtn = modal.querySelector('.QuickShopModal__Btn--solid');
      if(!addBtn) return;
      
      const prevText = addBtn.innerText;
      addBtn.innerText = 'ADDING...';
      addBtn.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        // Restore button
        addBtn.innerText = prevText;
        addBtn.disabled = false;
        
        closeQuickShop(productId);
        
        // Dispatch product:added event like ProductForm__AddToCart does
        // This will trigger theme.js to open the drawer and refresh cart
        const productAddedEvent = new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: { id: foundId },
            quantity: 1
          }
        });
        document.dispatchEvent(productAddedEvent);
        
        // Also dispatch cart:refresh for cart count updates
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch((error) => {
        addBtn.innerText = 'ERROR';
        setTimeout(() => { addBtn.innerText = prevText; addBtn.disabled = false; }, 2000);
      });
    } else {
      alert('Please select all options.');
    }
  };

  // Initialize modals that are already in the DOM
  function initializeExistingModals() {
    const modals = document.querySelectorAll('.QuickShopModal');
    modals.forEach(function(modal) {
      const modalId = modal.id;
      if(modalId && modalId.startsWith('QuickShopModal-')) {
        const productId = modalId.replace('QuickShopModal-', '');
        const defaultOptionsAttr = modal.getAttribute('data-default-options');
        const defaultOptions = defaultOptionsAttr ? defaultOptionsAttr.split('||') : [];

        if (defaultOptions.length) {
          const colorItems = modal.querySelectorAll('.QuickShopModal__ColorItem');
          colorItems.forEach(item => {
            const value = item.getAttribute('data-value');
            if (defaultOptions.includes(value)) {
              item.classList.add('is-selected');
            } else {
              item.classList.remove('is-selected');
            }
          });

          const sizeInputs = modal.querySelectorAll('input[name="size-' + productId + '"]');
          const defaultSize = defaultOptions.find(optionValue => Array.from(sizeInputs).some(input => input.value === optionValue));
          syncQuickShopSizeSelection(modal, productId, defaultSize);

        }

        const sizeInputs = modal.querySelectorAll('input[name="size-' + productId + '"]');
        sizeInputs.forEach(input => {
          if (!input.dataset.quickShopBound) {
            input.addEventListener('change', function() {
              syncQuickShopSizeSelection(modal, productId, this.value);
              window.updateQuickShopState(productId, modal);
            });
            input.dataset.quickShopBound = 'true';
          }
        });

        if (window.updateQuickShopState) {
          window.updateQuickShopState(productId, modal);
        }
      }
    });
  }

  // Extra safety: if theme re-renders modal nodes dynamically, still keep size class synced.
  document.addEventListener('click', function(event) {
    const sizeLabel = event.target.closest('.QuickShopModal__SizeOption');
    if (!sizeLabel) return;

    const modal = sizeLabel.closest('.QuickShopModal');
    if (!modal || !modal.id || modal.id.indexOf('QuickShopModal-') !== 0) return;

    const productId = modal.id.replace('QuickShopModal-', '');
    if (window.selectQuickShopSize) {
      window.selectQuickShopSize(sizeLabel, productId);
    }
  });

  // Safeguard: Ensure quick shop buttons remain clickable
  // This prevents issues where buttons become unclickable after modal closes
  function ensureButtonsClickable() {
    // Find all buttons with openQuickShop onclick
    const buttons = document.querySelectorAll('button[onclick*="openQuickShop"]');
    buttons.forEach(button => {
      // Ensure pointer events are enabled
      button.style.pointerEvents = 'auto';
      button.disabled = false;
      
      // If onclick is missing, restore it by parsing the attribute
      if(!button.onclick && button.getAttribute('onclick')) {
        const onclickAttr = button.getAttribute('onclick');
        // Extract productId from onclick string like "openQuickShop('12345', this)"
        const match = onclickAttr.match(/openQuickShop\(['"]([^'"]+)['"]/);
        if(match && match[1]) {
          const productId = match[1];
          button.addEventListener('click', function(e) {
            e.stopPropagation();
            if(window.openQuickShop) {
              window.openQuickShop(productId, this);
            }
          });
        }
      }
    });
  }
  
  // Run immediately on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeExistingModals();
      ensureButtonsClickable();
    });
  } else {
    initializeExistingModals();
    ensureButtonsClickable();
  }
  
  // Also run after DOM changes (using MutationObserver)
  if(typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      ensureButtonsClickable();
    });
    
    // Observe the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }
  
  // Also run on close to ensure buttons are restored
  const originalCloseQuickShop = window.closeQuickShop;
  if(originalCloseQuickShop) {
    window.closeQuickShop = function(productId) {
      originalCloseQuickShop.call(this, productId);
      // Ensure buttons are clickable after closing
      setTimeout(ensureButtonsClickable, 350);
    };
  }
})();

